<template>
  <div>
    <div class="hello">
    <span class="ppp">
     学习助手
    </span>
    <span class="rightclass">
     掌上班级
    </span>
    <span class="rightschool">
     轻松入学
    </span>
    <div class="box">
      <span class="title">学习助手APP</span>
      <span class="titletxt">您的掌上班级学习工具</span>
    </div>
    <div class="txtbtn">
     <span>在线班级课程;</span>
     <span>即时学习进度展示;</span>
     <span>更有多种名师店铺任你选。</span>
    </div>
    <div class="btnclose">立即下载</div>
  </div>
  <div class="bottom">
    <img class="imgage" src="../assets/矩形 1@2x.png" alt="">
    <span>公司：子信教育科技创新研究院</span>
    <span>联系方式：400-928-6877</span>
    <span>地址：江苏省苏州市工业园区仁爱路1号</span>
    <span>电子邮箱：yuanying@njzxdu.com</span>
    <span>苏公网安备32050043124-20001号</span>
    <span>增值电信业务经营许可证：苏B2-20190830</span>
    <span @click="zhuan()">苏ICP备19045551号-15</span>
    <img class="imgimg" src="../assets/矩形 2@2x.png" alt="">
  </div>
  </div>

</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  methods: {
    zhuan () {
      window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.hello{
  background: url(../assets/picture.png) no-repeat;
  background-size: 100% 100%;
  min-width: 1100px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  overflow: hidden;
  height: 953px;
}
.ppp{
  font-size: 30px;
font-weight: normal;
color: #FFFFFF;
position: absolute;
left: 360px;
top: 44px;
}
.rightclass{
  font-size: 16px;
font-weight: normal;
color: #FFFFFF;
position: absolute;
right: 480px;
top: 54px;
}
.rightschool{
  font-size: 16px;
font-weight: normal;
color: #FFFFFF;
position: absolute;
right: 360px;
top: 54px;
}
.box .title{
  font-size: 48px;
font-weight: normal;
color: #5675FE;
position: absolute;
left: 360px;
top: 427px;
}
.box .titletxt{
  font-size: 30px;
font-weight: normal;
color: #5675FE;
position: absolute;
left: 360px;
top: 505px;
}
.txtbtn{
  width: 288px;
height: 102px;
font-size: 24px;
font-weight: normal;
color: #5675FE;
position: absolute;
left: 360px;
top: 607px;
text-align: left;
}
.txtbtn span{
  display: block;
}
.btnclose{
  width: 240px;
height: 80px;
line-height: 80px;
background: #5675FE;
box-shadow: 0px 4px 10px 0px rgba(44,75,255,0.5);
border-radius: 10px 10px 10px 10px;
opacity: 1;
font-size: 30px;
font-weight: normal;
color: #FFFFFF;
position: absolute;
top: 779px;
left: 360px;
}
.bottom{
  width: 100%;
height: 200px;
background: #FEFEFE;
box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1);
border-radius: 0px 0px 0px 0px;
opacity: 1;
position: relative;
margin-top: 45px;
font-size: 16px;
font-family: Source Han Sans CN-Regular, Source Han Sans CN;
font-weight: 400;
color: #3D3D3D;
}
.bottom .imgage{
  width: 80px;
  height: 80px;
  position: absolute;
  top: 60px;
  left: 360px;
}
.bottom .imgimg{
  width: 120px;
  height: 120px;
  position: absolute;
  top: 40px;
  right: 360px;
}
.bottom span:nth-child(2){
  position: absolute;
  top: 62px;
  left: 480px;
  display: block;
}
.bottom span:nth-child(3){
  position: absolute;
  top: 62px;
  left: 812px;
  display: block;
}
.bottom span:nth-child(4){
  position: absolute;
  top: 62px;
  left: 1180px;
  display: block;
}
.bottom span:nth-child(5){
  position: absolute;
  top: 114px;
  left: 480px;
  display: block;
}
.bottom span:nth-child(6){
  position: absolute;
  top: 114px;
  left: 812px;
  display: block;
}
.bottom span:nth-child(7){
  position: absolute;
  top: 114px;
  left: 1180px;
  display: block;
}
.bottom span:nth-child(8){
  position: absolute;
  top: 166px;
  left: 480px;
  display: block;
}
</style>
